import type { LegalSection } from './legalMeta';
import { LEGAL_META } from './legalMeta';

export const supportPageTitle = 'Help & Support';

export const supportPageSections: LegalSection[] = [
  {
    id: 'about',
    title: `About ${LEGAL_META.brandName}`,
    paragraphs: [
      `${LEGAL_META.brandMark} is a mobile app for sharing memories tied to places. This page provides support information for the App and website.`,
    ],
  },
  {
    id: 'contact-support',
    title: 'Contact Us',
    paragraphs: [
      `Support: ${LEGAL_META.supportEmail} — app help, account access, abuse or safety reports (include “Report” in the subject line).`,
      `Legal & privacy: ${LEGAL_META.contactEmail} — privacy requests, terms, and legal notices.`,
      `Technical: ${LEGAL_META.itEmail} — bugs, technical issues, accessibility, or security concerns.`,
      `General: ${LEGAL_META.infoEmail} — press, partnerships, and other general inquiries.`,
      'We typically respond within a few business days.',
    ],
  },
  {
    id: 'faq',
    title: 'Common Topics',
    paragraphs: ['Helpful links:'],
    listItems: [
      'Delete some data without closing your account: see Delete Your Data on this site (delete posts, comments, or profile fields in the App).',
      'Delete your account: Settings → Account → Delete account in the App, or see Account Deletion on this site.',
      'Privacy and data: Privacy Policy on this site.',
      'Terms and community rules: Terms of Service and Community Guidelines.',
      'Password and login: use Forgot password in the App if you signed up with email.',
    ],
  },
];
